import React from 'react';

import { CheckCircleLabel, Container } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../../shared/providers';
import { ComplianceTable } from './ComplianceTable/ComplianceTable';
import { PageTitle } from '../../../shared/components/ui-components';

const NgzComplianceBoard = () => {
  return (
    <Container>
      <PageTitle title="Today's Compliance Board">
        <CheckCircleLabel>Only active users</CheckCircleLabel>
      </PageTitle>
      <ComplianceTable />
    </Container>
  );
};

angularizeWithProviders(NgzComplianceBoard, 'ngzComplianceBoard', {});

export default NgzComplianceBoard;
